export default function Navigation() {
  const scrollToPrograms = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const section = document.getElementById('programs');
    if (!section) return;
    section.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 bg-[#0d0d0d]/95 backdrop-blur-sm border-b border-white/6"
      aria-label="Mason Hale Fitness — Main navigation"
      role="navigation"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-4 flex items-center justify-between overflow-hidden">
        {/* Brand */}
        <a
          href="#top"
          onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
          className="flex items-center gap-2 sm:gap-3 cursor-pointer flex-shrink min-w-0"
          aria-label="Mason Hale Fitness — Return to homepage"
          title="Mason Hale — Over-60 Fitness Transformation"
        >
          <div className="w-7 h-7 flex items-center justify-center bg-[#c8a96e] rounded-sm flex-shrink-0">
            <i className="ri-user-line text-black text-sm" aria-hidden="true" />
          </div>
          <span className="text-white font-black text-sm tracking-[0.1em] sm:tracking-[0.22em] uppercase truncate">
            Mason Hale
          </span>
        </a>

        {/* Nav links — hidden on mobile */}
        <div className="hidden md:flex items-center gap-6">
          <a
            href="#story"
            onClick={(e) => { e.preventDefault(); document.getElementById('story')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="text-gray-400 hover:text-white text-xs font-semibold tracking-[0.15em] uppercase transition-colors duration-200 cursor-pointer whitespace-nowrap"
            aria-label="Read Mason's transformation story"
          >
            The Story
          </a>
          <a
            href="#testimonials"
            onClick={(e) => { e.preventDefault(); document.getElementById('testimonials')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="text-gray-400 hover:text-white text-xs font-semibold tracking-[0.15em] uppercase transition-colors duration-200 cursor-pointer whitespace-nowrap"
            aria-label="Read real customer results and testimonials"
          >
            Results
          </a>
          <a
            href="#faq"
            onClick={(e) => { e.preventDefault(); document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="text-gray-400 hover:text-white text-xs font-semibold tracking-[0.15em] uppercase transition-colors duration-200 cursor-pointer whitespace-nowrap"
            aria-label="Frequently asked questions about the program"
          >
            FAQ
          </a>
        </div>

        {/* CTA */}
        <a
          href="#programs"
          onClick={scrollToPrograms}
          className="inline-flex items-center gap-2 px-4 sm:px-5 py-2.5 bg-[#c8a96e] text-black text-xs font-black tracking-[0.15em] uppercase rounded-sm hover:bg-[#d9bc82] transition-all cursor-pointer whitespace-nowrap flex-shrink-0"
          aria-label="Get the Over-60 Strength Blueprint fitness program"
        >
          Get The Program
        </a>
      </div>
    </nav>
  );
}
